export default __webpack_public_path__ + "static/media/mescom-big-menu-logo.e48522e8.png";